module.exports = __webpack_public_path__ + "static/media/excel.ffad6b3c.png";